function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { couponPackageListApi } from '@/views/marketing/coupon/api';

// 假设这是发送券包给员工的API，需要根据实际情况修改
var sendPackagesToEmployeesApi = function sendPackagesToEmployeesApi(data) {
  return request({
    url: '/admin/coupon/packages/send-to-employees',
    method: 'POST',
    data: data
  });
};
import request from '@/utils/request';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      employeeData: {
        employees: [],
        customerIntegralId: null
      },
      form: {
        packageIds: []
      },
      packageOptions: [],
      packageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
      hasMorePackages: false,
      submitting: false
    };
  },
  methods: {
    open: function open(data) {
      this.employeeData = data;
      this.dialogVisible = true;
      this.loadPackages();
    },
    close: function close() {
      this.dialogVisible = false;
      this.form.packageIds = [];
      this.packageOptions = [];
      this.packageParams.page = 1;
      this.employeeData = {
        employees: [],
        customerIntegralId: null
      };
      this.submitting = false;
    },
    loadPackages: function () {
      var _loadPackages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return couponPackageListApi({
                page: this.packageParams.page,
                limit: this.packageParams.limit
              });
            case 1:
              res = _context.v;
              if (this.packageParams.page === 1) {
                this.packageOptions = res.list || [];
              } else {
                this.packageOptions = [].concat(_toConsumableArray(this.packageOptions), _toConsumableArray(res.list || []));
              }
              this.packageParams.total = res.total || 0;
              this.hasMorePackages = this.packageOptions.length < this.packageParams.total;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('获取券包列表失败');
              console.error('获取券包列表失败', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadPackages() {
        return _loadPackages.apply(this, arguments);
      }
      return loadPackages;
    }(),
    loadMorePackages: function loadMorePackages() {
      this.packageParams.page += 1;
      this.loadPackages();
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.$refs.formRef.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
                  var employeeIds, _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        if (valid) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        if (!(_this.form.packageIds.length === 0)) {
                          _context2.n = 2;
                          break;
                        }
                        _this.$message.warning('请选择至少一个券包');
                        return _context2.a(2);
                      case 2:
                        if (!(_this.employeeData.employees.length === 0)) {
                          _context2.n = 3;
                          break;
                        }
                        _this.$message.warning('没有选择员工');
                        return _context2.a(2);
                      case 3:
                        _this.submitting = true;
                        _context2.p = 4;
                        employeeIds = _this.employeeData.employees.map(function (employee) {
                          return employee.id;
                        });
                        _context2.n = 5;
                        return sendPackagesToEmployeesApi({
                          employeeIds: employeeIds,
                          packageIds: _this.form.packageIds,
                          customerIntegralId: _this.employeeData.customerIntegralId
                        });
                      case 5:
                        _this.$message.success('发送成功');
                        _this.$emit('refresh');
                        _this.close();
                        _context2.n = 7;
                        break;
                      case 6:
                        _context2.p = 6;
                        _t2 = _context2.v;
                        _this.$message.error(_t2.message || '发送失败');
                      case 7:
                        _context2.p = 7;
                        _this.submitting = false;
                        return _context2.f(7);
                      case 8:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[4, 6, 7, 8]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};